import firebase from "../services/Firebase.service"

const GoogleAuthProvider = new firebase.auth.GoogleAuthProvider();

const  MicrosoftAuthProvider = new firebase.auth.OAuthProvider('microsoft.com');
MicrosoftAuthProvider.setCustomParameters({
    prompt: "consent",
})

export {
    GoogleAuthProvider,
    MicrosoftAuthProvider
}